import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AuthService } from '../../auth/auth.service';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { TrainingService } from '../../services/training.service';

@Component({
    selector: 'stripe-training',
    template: require('./stripe.training.component.html')
})
export class StripeTrainingComponent {
    @Input() submitText = 'Submit Payment';
    @Input() showRenewal = false;
    @Output() success = new EventEmitter<any>();

    @BlockUI() blockSubmit: NgBlockUI;

    stripe: any;
    elements: any;
    paymentElement: any;

    errorMessage = '';
    automaticRenewal = true;
    agreedToTandCs = false;
    showMustAgreeError = false;

    private paymentElementMounted = false;

    constructor(
        private trainingService: TrainingService,
        private loggedInUserService: LoggedInUserService,
        private readonly authService: AuthService
    ) {
        this.stripe = (window as any).Stripe;
    }

    show() {
        if (this.paymentElementMounted) {
            return;
        }
        const user = this.loggedInUserService.getCurrentUser();
        this.trainingService.createPaymentIntent({
            selectedAccount: '',
            automaticRenewal: false,
            customerId: user.userId,
            email: user.email
        }).subscribe(
            (response: any) => {
                this.initPaymentElement(response.value.clientSecret);
            },
            (err: any) => {
                const apiMessages = err && err.error && err.error.messages;

                if (apiMessages && Array.isArray(apiMessages) && apiMessages.length > 0) {
                    this.errorMessage = apiMessages.join(' ');
                } else {
                    this.errorMessage = 'Failed to initialise payment. Please try again.';
                }
            }
        );
    }

    private initPaymentElement(clientSecret: string) {
        this.destroyPaymentElement();
        this.elements = this.stripe.elements({
            clientSecret,
            appearance: { theme: 'stripe' }
        });
        this.paymentElement = this.elements.create('payment');
        this.paymentElement.mount('#payment-element');
        this.paymentElementMounted = true;
    }

    private destroyPaymentElement() {
        if (this.paymentElement) {
            this.paymentElement.destroy();
            this.paymentElement = null;
        }
        this.elements = null;
        this.paymentElementMounted = false;
    }

    async charge() {
        if (!this.agreedToTandCs) {
            this.showMustAgreeError = true;
            return;
        }

        this.showMustAgreeError = false;

        if (!this.showRenewal) {
            this.automaticRenewal = true;
        }

        this.blockSubmit.start(
            'Processing your payment. This may take up to a minute. Do not refresh the page.'
        );

        try {
            const result = await this.stripe.confirmPayment({
                elements: this.elements,
                confirmParams: {
                    return_url: window.location.href,
                },
                setup_future_usage: 'on_session',
                redirect: 'if_required',
            });

            if (result.error) {
                this.blockSubmit.stop();
                this.errorMessage = result.error.message || 'Payment failed';
            } else if (result.paymentIntent.status === 'succeeded') {
                this.errorMessage = '';
                this.success.emit({
                    source: 0,
                    threeDSecure: 0,
                    clientSecret: result.paymentIntent.client_secret
                });
            } else {
                this.blockSubmit.stop();
                this.errorMessage = `Unexpected payment status: ${result.paymentIntent && result.paymentIntent.status}`;
            }
        } catch (err) {
            this.blockSubmit.stop();
            console.error('Stripe confirmPayment error', err);
            this.errorMessage = 'Unexpected error confirming payment';
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/training/stripe.training.component.ts